module.exports = __webpack_public_path__ + "static/media/the-dearly-beloved.a1f34bda.jpg";